import { z } from 'zod';
export const USAGES_IMAGE = ['site', 'plateformes', 'reseaux', 'presse', 'impression'];
export const droitsImageSchema = z.strictObject({
    titulaire: z.string().trim().min(1).max(200),
    usages: z
        .array(z.enum(USAGES_IMAGE))
        .max(5)
        .refine((usages) => new Set(usages).size === usages.length),
    echeance: z.iso.datetime().nullable().default(null),
    note: z.string().trim().max(300).default(''),
});
/** Les droits absents conservent la liberté de publication existante. */
export function usageAutorise(droits, usage, maintenant) {
    if (droits == null)
        return true;
    return (droits.usages.includes(usage) &&
        (droits.echeance === null || new Date(droits.echeance).getTime() > maintenant.getTime()));
}
//# sourceMappingURL=droits-image.js.map